import validator from 'validator';
import FormValidator from './../../helpers/FormValidator';
import createRule from './../../helpers/createRule';

const rules = {
  apellido: {
    validate: function (value) {
      let errors = [];

      if (typeof value !== 'string') {
        errors.push('Tipo incorrecto');
      }

      if (value.length > 255) {
        errors.push('Supero cantidad maxima de caracteres (255 MAX)');
      }

      return errors;
    }
  },
  nombre: {
    validate: createRule([
      ['isEmail', 'email incorrecto'],
      [(value) => validator.isLength(value, { min: 3, max: 20}), 'fuera de rango'],
      ['isLowercase', 'debe ser minuscula']
    ])
  }
};

const PersonaValidator = new FormValidator(rules);

export default PersonaValidator;


// WEBPACK FOOTER //
// ./client/services/validators/PersonaValidator.js